const searchFacetSelectJsClass = 'js-search-facet-select';
const selectJsClass = searchFacetSelectJsClass + '-select';

const searchFacetSelectElements = document.querySelectorAll('.' + searchFacetSelectJsClass);

if (searchFacetSelectElements.length > 0) {
    searchFacetSelectElements.forEach((searchFacetSelectElement) => {
        // We get the select element
        const selectElement = searchFacetSelectElement.querySelector('.' + selectJsClass) as HTMLSelectElement;

        if (selectElement) {
            // We add a change event listener
            selectElement.addEventListener('change', () => {
                // If the option has a value
                if (selectElement.value) {
                    // We navigate to the url in the value of the open
                    window.location.href = selectElement.value;
                }
            });
        }
    });
}